import React, { createContext, useContext } from 'react'
import { useIPOrganismosReducer } from '../hooks/ip-organismos-reducer.hook'

const IPOrganismosContext = createContext()

export const IPOrganismosContextProvider = ({ children }) => {
  const reducer = useIPOrganismosReducer()
  return <IPOrganismosContext.Provider value={reducer}>{children}</IPOrganismosContext.Provider>
}

export const useIPOrganismosContext = () => useContext(IPOrganismosContext)
